import PropTypes from "prop-types"
import React from "react"
import AuthorAvatars from "components/AuthorAvatars"
import Card from "components/Card"
import Thumbnail from "components/Thumbnail"
import * as css from "./BlogPostListingItem.module.css"

function BlogPostListingItem({
  slug,
  title,
  author,
  thumbnail,
  thumbnailAlt,
  category,
}) {
  return (
    <Card
      className={css.card}
      href={/https?:/.test(slug) ? slug : `/blog/${slug}/`}
      target={/https?:/.test(slug) ? "_blank" : null}
    >
      <Thumbnail thumbnail={thumbnail} alt={thumbnailAlt || title} />
      <div className={css.cardContent}>
        <div className={css.cardHeader}>{title}</div>
      </div>
      <div className={css.cardContentExtra}>
        <div className={css.meta}>
          <AuthorAvatars author={author} size={24} />
          <div className={css.category}>{category}</div>
        </div>
      </div>
    </Card>
  )
}

BlogPostListingItem.propTypes = {
  /** The path to the blog post */
  slug: PropTypes.string.isRequired,
  /** The title of the blog post, used as the thumbnail alt fallback */
  title: PropTypes.string.isRequired,
  /** Descriptive alt text for the thumbnail; falls back to title when absent */
  thumbnailAlt: PropTypes.string,
  /** The author of the blog post */
  author: PropTypes.string.isRequired,
  /** The category of the blog post */
  category: PropTypes.string.isRequired,
}

export default BlogPostListingItem
